require(['main'],function() {
  require(['modules/feedback/feedback']);
  require(['wrap!bootstrap']);
  require(['modules/chooseadaf'],function(ChooseADaf) {
    $(function() {
      new ChooseADaf({el:$("#chooseADaf")});
    });
  });
});
define("pages/layout", function(){});

